import {styled} from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`
    border-radius: 0!important;
    position: fixed;
    top: 0;
    z-index: 999;

    /* For desktop view (centered phone-width container) */
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 380px; /* or 430px for larger phones */

    /* For actual mobile devices */
    @media (max-width: 425px) {
        max-width: 90%;

        left: 50%;
        transform: translateX(-50%);
        border-radius: 0;
    }
  border: none;
  box-shadow: 0px 18px 20px -31px rgba(0,0,0,0.45);
.ant-card-body{
  padding: 24px 0px;

}  
  
`;